import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
export default {
  name: 'NiotaClassicDevicetypesSyncronizeHealthStatesDialog',
  props: {
    dialogSyncHealthStateOpen: {
      type: Boolean,
      default: false
    },
    tenantId: {
      type: Number,
      default: null
    },
    linkedVirtualDevicesIds: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      jobTitle: ''
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions'])), {}, {
    getTotalDevicesNumber: function getTotalDevicesNumber() {
      return this.linkedVirtualDevicesIds.length;
    },
    rules: function rules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.required');
      }, function (v) {
        return (v.trim() || '').length <= 50 || _this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.max', {
          n: 50
        });
      }, function (v) {
        return (v.trim() || '').length >= 5 || _this.$i18n_t('DigitalTwin.VirtualDevice.bulkUpdate.errors.min', {
          n: 5
        });
      }];
    },
    isApplyBtnInDialogDisabled: function isApplyBtnInDialogDisabled() {
      return this.jobTitle.length < 5 || this.jobTitle.length > 50;
    }
  }),
  methods: {
    closeSyncHealthStateDialog: function closeSyncHealthStateDialog() {
      this.jobTitle = '';
      this.$emit('close');
    },
    syncHealthStates: function syncHealthStates() {
      var _this2 = this;

      var data = {
        entities: this.linkedVirtualDevicesIds,
        tenantId: this.tenantId,
        title: this.jobTitle,
        executions: {
          syncHealthConfiguration: true
        }
      };
      ApiService.createBackgroundRunnerBulkEdit(data).then(function () {
        _this2.closeSyncHealthStateDialog();

        _this2.$snack(_this2.$i18n_t('DigitalTwin.VirtualDevice.bulkEditSuccess', {
          n: _this2.getTotalDevicesNumber
        }), 'success');
      }).catch(function (error) {
        _this2.closeSyncHealthStateDialog();

        _this2.$snack(_this2.$i18n_t("Error.".concat(error.response.data.message)), 'error');
      });
    }
  }
};